import { Table } from '@project/components';
import React from 'react'
import { useIntl } from 'react-intl';

const COITable = ({ certificates, loading }) => {
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  return (
    <Table
      key="certificatesTable"
      idField={'id'}
      label={''}
      items={certificates || []}
      sortFields={['insuranceStartDate', 'insuranceEndDate', 'sentStatus']}
      fields={[
        {
          id: 'insuranceStartDate',
          type: 'datetime',
          label: t('Settings.certificateInsurance.table.startDate'),
          incomingFormat: 'MM/DD/YYYY',
          format: 'l'
        },
        {
          id: 'insuranceEndDate',
          type: 'datetime',
          label: t('Settings.certificateInsurance.table.endDate'),
          incomingFormat: 'MM/DD/YYYY',
          format: 'l'
        },
        {
          id: 'sentStatus',
          type: 'status',
          label: t('SearchTable.status'),
          statusColors: [
            {
              condition: certificate => certificate.sentStatus === t("term.expired"),
              color: { backgroundColor: 'rgba(255, 0, 0, 0.1)', color: 'rgb(215,1,1)' }
            },
            {
              condition: certificate => certificate.sentStatus === t("term.active"),
              color: { backgroundColor: 'rgba(55, 182, 91, 0.1)', color: '#37b65b' }
            },
            {
              condition: certificate => certificate.sentStatus === t("term.notActive"),
              color: { backgroundColor: 'rgba(109, 113, 117, 0.1)', color: '#6d7175'}
            }
          ]
        },
        {
          id: 'document',
          type: 'fragment',
          label: t('term.document'),
          renderFragment: (certificate) => {
            return certificate.documentUrl ? (
              <a href={certificate.documentUrl} download>
                {certificate.UploadedFile?.dataValues?.filename || "Document"}
              </a>
            ) : "No Document Available";
          }
        }
      ]}
      isLoading={loading}
      hideSearch={true}
      hideTableHeader={false}
      hidePaginate={certificates?.length <= 10}
      customWidths={['40%', '30%', '20%', '10%', '10%']}
      customStyle={`mb-5`}
      borderBottomLastItem={true}
      rowPlaceholderHeight={'71px'}
      scrollHeight={'300px'}
    ></Table>
  );
}

export default COITable
